import React, { useState } from "react";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../Context/UseAuthContext";
import ProfileNavbar from "../../components/Navbar/ProfileNavbar";
import Footer from "../../components/Footer/Footer";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { logIn, googleSignIn } = useUserAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await logIn(email, password);
      navigate("/start");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    try {
      await googleSignIn();
      navigate("/start");
    } catch (error) {
      //console.log(error.message);
    }
  };

  return (
    <>
      <ProfileNavbar />
      <div className="login">
        <h1>Welcome Back</h1>
        <h2>Log into your DepRelief Account</h2>
        <div className="login-form">
          {error && <alert>{error}</alert>}
          <form onSubmit={handleSubmit}>
            <label>Email</label>
            <br />
            <input
              name="email"
              type="email"
              placeholder="Example@email.com"
              onChange={(e) => setEmail(e.target.value)}
            />
            <br />
            <label>Password</label>
            <br />
            <input
              name="password"
              type="password"
              placeholder="Enter Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <br />
            <button className="submit-btn" type="Submit">
              Log In
            </button>
            <p>
              Don't have an account? <Link to="/signup"> SignUp</Link>
            </p>
            <button
              className="google-btn"
              type="Submit"
              onClick={handleGoogleSignIn}
            >
              Sign In With Google
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
